/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_SuspendedInputs */

const en_signin_sso_x15_suspended = /** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your access to this workspace is paused. Ask your admin to restore it.`)
};

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const ar_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const he_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const ur_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const es_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const fr_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const de_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const pt_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const hi_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/** @type {(inputs: Signin_Sso_X15_SuspendedInputs) => LocalizedString} */
const bn_signin_sso_x15_suspended = en_signin_sso_x15_suspended;

/**
* | output |
* | --- |
* | "Your access to this workspace is paused. Ask your admin to restore it." |
*
* @param {Signin_Sso_X15_SuspendedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_suspended = /** @type {((inputs?: Signin_Sso_X15_SuspendedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_SuspendedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_x15_suspended(inputs)
	if (locale === "he") return he_signin_sso_x15_suspended(inputs)
	if (locale === "ur") return ur_signin_sso_x15_suspended(inputs)
	if (locale === "es") return es_signin_sso_x15_suspended(inputs)
	if (locale === "fr") return fr_signin_sso_x15_suspended(inputs)
	if (locale === "de") return de_signin_sso_x15_suspended(inputs)
	if (locale === "pt") return pt_signin_sso_x15_suspended(inputs)
	if (locale === "hi") return hi_signin_sso_x15_suspended(inputs)
	if (locale === "bn") return bn_signin_sso_x15_suspended(inputs)
	return /** @type {LocalizedString} */ ("Your access to this workspace is paused. Ask your admin to restore it.")
});